
/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 25/10/2020
 */


let CreateTaskDialog = () => import("@/core/components/Dialogs/DetailsTaskDialog.vue");
let CreateNoteDialog = () => import("@/core/modules/coach/Programs/Dialogs/DetailsNoteDialog.vue");
let ProgramSectionDialog = () => import("@/core/components/Dialogs/ProgramSectionEditDialog.vue");
let ProgramItemEditDialog = () => import("@/core/components/Dialogs/ProgramItemEditDialog.vue");
let AddContractDialog = () => import("@/core/modules/coach/Programs/Dialogs/AddContractDialog.vue");
let SessionChangeTypeDialog = () => import("@/core/modules/coach/Programs/Dialogs/SessionChangeTypePickerDialog.vue");

// import CreateTaskDialog from "@/core/components/Dialogs/DetailsTaskDialog.vue";
// import CreateNoteDialog from "@/core/modules/coach/Programs/Dialogs/DetailsNoteDialog.vue";
// import ProgramSectionDialog from "@/core/components/Dialogs/ProgramSectionEditDialog.vue";
// import ProgramItemEditDialog from "@/core/components/Dialogs/ProgramItemEditDialog.vue";
// import AddContractDialog from "@/core/modules/coach/Programs/Dialogs/AddContractDialog.vue";
//
// import SessionChangeTypeDialog from "@/core/modules/coach/Programs/Dialogs/SessionChangeTypePickerDialog.vue";

import {createDialogLazy} from "@/utils/helpers-external.js";


export const createTaskDialog = createDialogLazy(CreateTaskDialog)
export const createSectionDialog = createDialogLazy(ProgramSectionDialog)
export const createNoteDialog = createDialogLazy(CreateNoteDialog)
// export const addContractDialog = createDialogLazy(AddContractDialog, 'viewMode', 'dataItem', 'programItem', 'eventFn', 'programType', 'clientList')
export const addContractDialog = createDialogLazy(AddContractDialog)
export const editProgramItemDialog = createDialogLazy(ProgramItemEditDialog)

export const sessionChangeTypeDialog = createDialogLazy(SessionChangeTypeDialog, 'viewMode', 'availableOptions')


